import styled from "styled-components";

export const TimerLogBoxWrapper = styled.div`
  width: 1280px;
  height: 768px;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 13px;
  overflow: hidden;
`;

export const TimerLogHeaderWrapper = styled.div`
  width: calc(100% - 114px);
  padding: 40px 39px 40px 75px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  > .title {
    color: #1a191a;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .right {
    display: flex;
    gap: 10px;
    align-items: center;

    > .close-button {
      width: 40px;
      margin-right: 10px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const TimerLogSearchWrapper = styled.div`
  top: 40px;
  right: 75px;
  width: 270px;
  height: 20px;
  padding: 10px 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e5e5;

  > .search-input {
    width: 250px;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border: none;
    outline: none;
    background: transparent;
  }
  > .search-button {
    width: 20px;
    height: 20px;
  }
`;

export const TimerLogContentWrapper = styled.div`
  width: calc(100% - 117px);
  padding: 0px 77px 30px 40px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const TimerLogContentHeaderWrapper = styled.div`
  width: 100%;
  height: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 15px 10px;
  > .title {
    text-align: center;
    flex: 1;
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const TimerLogContentItemWrapper = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 15px;
  border-radius: 11.466px;
  background: #ecf0f3;

  > .value {
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    flex: 1;

    &.bold {
      font-weight: 700;
    }
  }

  > .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2px;

    > .level {
      background: #373636;
      font-family: Pretendard;
      font-weight: 700;
      font-size: 12px;
      line-height: 100%;
      text-align: center;
      color: #fff;
      width: 99px;
      height: 18px;
      border-radius: 5px;
      angle: 0 deg;
      gap: 2px;
      padding: 2px;
      box-sizing: border-box;
    }
  }
`;

export const TimerLogPaginationWrapper = styled.div`
  position: absolute;
  bottom: 60px;
  right: 50%;
  transform: translateX(50%);
`;
